import Reflux from 'reflux';
const _ = require('underscore');

var IntercomActions = Reflux.createActions([
  'boot',
  'hideChat',
  'startChat',
  'productUpgrade',
  'categoriesMigration',
  'updateSettings',
]);

function isAutomatedTestEmail(email) {
  const exclusions = ['automation', 'cypress', 'test', 'playwright'];
  return (
    _.any(exclusions, (ex) => email.includes(ex)) &&
    (email.includes('@shoflo.tv') || email.includes('@cvent.com'))
  );
}

IntercomActions.startChat.listen((topic) => {
  window.Intercom('trackEvent', topic);
});

function isPrintablePage() {
  const path = window.location.pathname || '';
  return path.includes('/printable') || path.includes('/pdf/view');
}

IntercomActions.boot.listen((data) => {
  if (isPrintablePage()) {
    return;
  }
  if (isAutomatedTestEmail(data.email)) {
    window.Intercom = (operation) => {
      console.log(`Intercom is disabled..not running ${operation} operation`);
    };
  }

  window.Intercom('boot', {
    app_id: window.globals.intercomAppId,
    ...data,
  });
});

IntercomActions.productUpgrade.listen((product) => {
  window.Intercom('trackEvent', `requested-${product}-upgrade`);
  window.Intercom(
    'showNewMessage',
    `I'm interested in upgrading to ${product}. Can you tell me more?`,
  );
});

// eslint-disable-next-line no-unused-vars
IntercomActions.categoriesMigration.listen((product) => {
  window.Intercom(
    'showNewMessage',
    `Can you tell me more about how converting my categories to tags will work?`,
  );
});

IntercomActions.hideChat.listen((bool) => {
  window.Intercom('update', { hide_default_launcher: bool });
});

export default IntercomActions;
